module.exports = __webpack_public_path__ + "img/Photo_2__Shipbuilding_976_280_3.6578bd60.jpg";